
import { useEffect, useState } from 'react';

import { observer } from 'mobx-react-lite';
import Stack from '@mui/joy/Stack';


import useFHRequest from 'hooks/useFHRequest';
import useWorkKey from 'hooks/useWorkKey';
import { REQUEST_STATUS } from 'utils/misc';
import WorkListItem from './WorkListItem';
import { byDate } from 'utils/sort';
import { Button } from '@mui/joy';


const OpenRoute = observer(() => {

    const [fetchingList, setFetchingList] = useState(false);
    const [cursor, setCursor] = useState<string|null>(null);

    const { fetchListAllOpen, items } = useFHRequest();

    const workKey = useWorkKey();
    const openRequests = items.filter((item) => item.status < REQUEST_STATUS.CLOSED).slice().sort(byDate).reverse();

    function loadRequests() {
        if (workKey) {
            fetchListAllOpen(workKey, cursor).then((c) => {
                console.log("got cursor: ", c);
                c && setCursor(c);
                setFetchingList(false);
            });
        }
    }


  useEffect(() => {
        document.title = "Open Tasks";
  }, []);

    useEffect(() => {
        loadRequests();
    }, [workKey]);



    return (
        <Stack spacing={1}>

                {openRequests.map((request) => (
                        <WorkListItem key={request.uuid} item={request} />

                ))}

            {cursor &&
                <Stack pb={5}>
                    <Button disabled={fetchingList} onClick={loadRequests} size="sm">Load More</Button>
                </Stack>
            }
        </Stack>
    );
});

export default OpenRoute;
